export default "__VITE_ASSET__xkqhxcFv__"